import type { Instrument } from '@thinkalpha/common/schemas/instruments.js';

/** @deprecated */
export type UpdateTradeProSymbolAction = { type: 'updateTradeProSymbol'; tabId: string; symbol: string };
/** @deprecated */
export const updateTradeProSymbol = (tabId: string, symbol: string): UpdateTradeProSymbolAction => ({
    tabId,
    symbol,
    type: 'updateTradeProSymbol',
});

/** @deprecated */
type UserSelectedNewTradeProSymbolAction = {
    type: 'userSelectedNewTradeProSymbol';
    symbol: string;
    tabId: string;
};

/** @deprecated */
export const userSelectedNewTradeProSymbol = (tabId: string, symbol: string): UserSelectedNewTradeProSymbolAction => ({
    symbol,
    tabId,
    type: 'userSelectedNewTradeProSymbol',
});

export type UpdateTradeProAccountAction = {
    type: 'updateTradeProAccount';
    tabId: string;
    accountId: string | null;
};
export const updateTradeProAccount = (tabId: string, accountId: string | null): UpdateTradeProAccountAction => ({
    tabId,
    accountId,
    type: 'updateTradeProAccount',
});

export type UserSelectedTradeProAccountAction = {
    type: 'userSelectedTradeProAccount';
    tabId: string;
    accountId: string;
};
export const userSelectedTradeProAccount = (tabId: string, accountId: string): UserSelectedTradeProAccountAction => ({
    tabId,
    accountId,
    type: 'userSelectedTradeProAccount',
});

export type UpdateTradeProInstrumentAction = {
    type: 'updateTradeProInstrument' | 'linkingUpdateTradeProInstrument';
    tabId: string;
    instrument: Instrument;
};
export const updateTradeProInstrument = (
    tabId: string,
    instrument: Instrument,
    isLinking = false,
): UpdateTradeProInstrumentAction => ({
    tabId,
    instrument,
    type: isLinking ? 'linkingUpdateTradeProInstrument' : 'updateTradeProInstrument',
});

export type UpdateTradeProQuantityAction = {
    type: 'updateTradeProQuantity';
    tabId: string;
    quantity: number;
};
export const updateTradeProQuantity = (tabId: string, quantity: number): UpdateTradeProQuantityAction => ({
    tabId,
    quantity,
    type: 'updateTradeProQuantity',
});

export type TradeProActions =
    | UpdateTradeProSymbolAction
    | UserSelectedNewTradeProSymbolAction
    | UpdateTradeProAccountAction
    | UserSelectedTradeProAccountAction
    | UpdateTradeProInstrumentAction
    | UpdateTradeProQuantityAction;
